/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "onti",
        "0": "oji",
        "1": "manhan",
        "future": {
          "other": "di li {0} dia"
        },
        "past": {
          "other": "a ten {0} dia"
        }
      },
      "day-narrow": {
        "-1": "onti",
        "0": "oji",
        "1": "manhan",
        "future": {
          "other": "di li {0} dia"
        },
        "past": {
          "other": "a ten {0} dia"
        }
      },
      "day-short": {
        "-1": "onti",
        "0": "oji",
        "1": "manhan",
        "future": {
          "other": "di li {0} dia"
        },
        "past": {
          "other": "a ten {0} dia"
        }
      },
      "hour": {
        "0": "es ora li",
        "future": {
          "other": "di li {0} ora"
        },
        "past": {
          "other": "a ten {0} ora"
        }
      },
      "hour-narrow": {
        "0": "es ora li",
        "future": {
          "other": "di li {0} ora"
        },
        "past": {
          "other": "a ten {0} ora"
        }
      },
      "hour-short": {
        "0": "es ora li",
        "future": {
          "other": "di li {0} ora"
        },
        "past": {
          "other": "a ten {0} ora"
        }
      },
      "minute": {
        "0": "es minutu li",
        "future": {
          "other": "di li {0} minutu"
        },
        "past": {
          "other": "a ten {0} minutu"
        }
      },
      "minute-narrow": {
        "0": "es minutu li",
        "future": {
          "other": "di li {0} m"
        },
        "past": {
          "other": "a ten {0} m"
        }
      },
      "minute-short": {
        "0": "es minutu li",
        "future": {
          "other": "di li {0} min"
        },
        "past": {
          "other": "a ten {0} min"
        }
      },
      "month": {
        "-1": "mes pasadu",
        "0": "es mes li",
        "1": "prósimu mes",
        "future": {
          "other": "di li {0} mes"
        },
        "past": {
          "other": "a ten {0} mes"
        }
      },
      "month-narrow": {
        "-1": "mes pasadu",
        "0": "es mes li",
        "1": "prósimu mes",
        "future": {
          "other": "di li {0} mes"
        },
        "past": {
          "other": "a ten {0} mes"
        }
      },
      "month-short": {
        "-1": "mes pasadu",
        "0": "es mes li",
        "1": "prósimu mes",
        "future": {
          "other": "di li {0} mes"
        },
        "past": {
          "other": "a ten {0} mes"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "trimestri pasadu",
        "0": "es trimestri li",
        "1": "prósimu trimestri",
        "future": {
          "other": "di li {0} trimestri"
        },
        "past": {
          "other": "a ten {0} trimestri"
        }
      },
      "quarter-narrow": {
        "-1": "trimestri pasadu",
        "0": "es trimestri li",
        "1": "prósimu trimestri",
        "future": {
          "other": "di li {0} trim."
        },
        "past": {
          "other": "a ten {0} trim."
        }
      },
      "quarter-short": {
        "-1": "trimestri pasadu",
        "0": "es trimestri li",
        "1": "prósimu trimestri",
        "future": {
          "other": "di li {0} trim."
        },
        "past": {
          "other": "a ten {0} trim."
        }
      },
      "second": {
        "0": "agora",
        "future": {
          "other": "di li {0} sigundu"
        },
        "past": {
          "other": "a ten {0} sigundu"
        }
      },
      "second-narrow": {
        "0": "agora",
        "future": {
          "other": "di li {0} s"
        },
        "past": {
          "other": "a ten {0} s"
        }
      },
      "second-short": {
        "0": "agora",
        "future": {
          "other": "di li {0} sig"
        },
        "past": {
          "other": "a ten {0} sig"
        }
      },
      "week": {
        "-1": "simana pasadu",
        "0": "es simana li",
        "1": "prósimu simana",
        "future": {
          "other": "di li {0} simana"
        },
        "past": {
          "other": "a ten {0} simana"
        }
      },
      "week-narrow": {
        "-1": "simana pasadu",
        "0": "es simana li",
        "1": "prósimu simana",
        "future": {
          "other": "di li {0} sim."
        },
        "past": {
          "other": "a ten {0} sim."
        }
      },
      "week-short": {
        "-1": "simana pasadu",
        "0": "es simana li",
        "1": "prósimu simana",
        "future": {
          "other": "di li {0} sim."
        },
        "past": {
          "other": "a ten {0} sim."
        }
      },
      "year": {
        "-1": "anu pasadu",
        "0": "es anu li",
        "1": "prósimu anu",
        "future": {
          "other": "di li {0} anu"
        },
        "past": {
          "other": "a ten {0} anu"
        }
      },
      "year-narrow": {
        "-1": "anu pasadu",
        "0": "es anu li",
        "1": "prósimu anu",
        "future": {
          "other": "di li {0} anu"
        },
        "past": {
          "other": "a ten {0} anu"
        }
      },
      "year-short": {
        "-1": "anu pasadu",
        "0": "es anu li",
        "1": "prósimu anu",
        "future": {
          "other": "di li {0} anu"
        },
        "past": {
          "other": "a ten {0} anu"
        }
      }
    },
    "locale": "kea"
  });
}